import { replaceTemplateVariables as n } from "../string-template.js";
import { cookieSchema as d } from "@scalar/oas-utils/entities/cookie";
import { isDefined as c } from "@scalar/oas-utils/helpers";
import { encode as w } from "js-base64";
const m = (l = [], i = {}, s = "") => {
  const t = {}, e = [], f = new URLSearchParams();
  return l.forEach((o) => {
    var p;
    if (o.type === "apiKey") {
      const a = n(o.value, i) || s;
      o.in === "header" && (t[o.name] = a), o.in === "query" && f.append(o.name, a), o.in === "cookie" && e.push(
        d.parse({
          uid: o.uid,
          name: o.name,
          value: a,
          path: "/"
        })
      );
    }
    if (o.type === "http")
      if (o.scheme === "basic") {
        const a = n(o.username, i), u = n(o.password, i), r = `${a}:${u}`;
        t.Authorization = `Basic ${r === ":" ? "username:password" : w(r)}`;
      } else {
        const a = n(o.token, i);
        t.Authorization = `Bearer ${a || s}`;
      }
    if (o.type === "oauth2") {
      const u = (p = Object.values(o.flows).filter(c).find((r) => r.token)) == null ? void 0 : p.token;
      t.Authorization = `Bearer ${u || s}`;
    }
  }), { headers: t, cookies: e, urlParams: f };
};
export {
  m as buildRequestSecurity
};
